import { restClient } from '../../client';
import { MentalHealthRole, ProviderDetail, State, User, UserContact, UserProfile } from '../../resources';

export type GetProviderSettingsResponse = {
  user: User;
  profile?: UserProfile;
  providerDetails?: ProviderDetail;
  contacts: UserContact[];
  states: State[];
  mentalHealthRoles: MentalHealthRole[];
};

export const getProviderSettings = restClient.createRequest<null, GetProviderSettingsResponse>({
  url: '/api/v1/provider/settings',
  method: 'GET'
});
